import axios from "axios"
import { CONST_API_RECRUITMENT_CANDIDATES_POST_LISTING } from "../../../../../../endpoints"
import { ISearchResultsRequestModel, ISearchResultsResponseModel } from "./_models"

export function getCandidateSearchResults(filters: ISearchResultsRequestModel) {
     return axios.post<ISearchResultsResponseModel>(CONST_API_RECRUITMENT_CANDIDATES_POST_LISTING, filters)
}
